import { Component, OnInit } from '@angular/core';
import { DescargaService } from './../_services/descargas.service';
import { DescargaRespuesta } from './../_models/descargas';

@Component({
  selector: 'app-documentos',
  templateUrl: './documentos.component.html',
  styleUrls: ['./documentos.component.css']
})
export class DocumentosComponent implements OnInit {
  respuesta: DescargaRespuesta = new DescargaRespuesta();
  textoIntro: string = 'En esta sección encontrará información útil y documentos descargables realcionados a los medios de denunucia de Zoonosis.';

  constructor(private service: DescargaService) {}

  ngOnInit() {
    this.service.getAll('files-documentos').subscribe(
      datos => {
        this.respuesta = datos;
      }
    );
  }
}
